<template>
  <div class="device-list">
    <!--    主要内容-->
    <div class="main">
      <clouded-glass class="space-choose clearfix">
        <div class="h-100 overflow" slot="content">
          <div class="current-location" style="margin-right: 21px;">
            <el-input class="inline-input" v-model="name" placeholder="请输入搜索的空间名称" size="mini"
                      @change="changeName"/>
          </div>
          <div class="current-location">
            <img alt="" src="../../../../assets/images/icon/location.png">
            <div style="vertical-align: middle;display: inline-block;margin-left: 8px">
              当前空间:
              <span class="text-nowrap">{{ spaceInfo.title }}</span>
            </div>
          </div>
          <space-tree-show :space-id="currentSpaceId || (selectSpaceInfo ? selectSpaceInfo.id : null)" @spaceChoose="spaceChoose"
                           :checkShow=true
                           @getAllDevice="getAllDevice"
                           class="space" ref="spaceTree"/>
        </div>
      </clouded-glass>
      <!--    搜索框-->
      <el-row class="search-media" style="height: 35px;border-bottom: 1px solid #145792;margin-left: 220px">
        <el-col :xl="5" :lg="6" style="height: 100%;display: flex;align-items: flex-end;padding-bottom: 7px">
          <img alt="点击搜索" style="height: 18px;width: 15px;margin-left: 16px;margin-bottom: 3px"
               src="../../../../assets/images/icon/设备总数.png">
          <div class="deviceCount">{{spaceInfo.title}}设备总数：<span style="font-size: 16px;color: #FFFFFF;">{{ deviceCount }}</span></div>
        </el-col>
        <el-col :xl="19" :lg="17"
                style="text-align: right;display: flex;align-items: flex-end;height: 100%;justify-content: flex-end">
          <div class="search-content">
            <div class="d-inline-block" style="width: 80px;">设备类型：</div>
            <el-select v-model="typeEngName" clearable placeholder="请选择" size="mini"  class="pr-5"
              style="width: 240px;">
              <el-option v-for="item in deviceCategory" :key="item.id" :label="item.cnName" :value="item.engName">
              </el-option>
            </el-select>
          </div>
          <div class="search-content">
            <div class="d-inline-block" style="width: 80px;">设备名称：</div>
            <el-input placeholder="输入设备名称搜索"  style="width: 240px;"  size="mini"  v-model="deviceName"></el-input>
            <!-- <div @click="getDeviceList(deviceName)" class="search-btn">
              <img alt="点击搜索" src="../../../../assets/images/icon/search.png">
            </div> -->
          </div>
          <div style="padding-bottom:8px;margin-left: 20px">
            <el-button size="mini"  type="primary" @touchstart="getDeviceList" @click="getDeviceList" >查询</el-button>
          </div>
        </el-col>
      </el-row>
      <device-tag-comp :device-info-list="deviceInfoList" :device-tag-list="deviceTagList" :hasDevice="hasDevice"
                       class="device-list overflow"/>
    </div>

  </div>
</template>

<script>

import DeviceTagComp from "@/views/basic_operations/monitoring/device_list/comp/DeviceTagComp";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import CloudedGlass from "@/components/style/CloudedGlass";
import {getListWithTagBySpaceId} from "@/network/device-info";
import {getDeviceCategoryList} from "@/network/device-category";

export default {
  name: "DeviceList",
  components: {DeviceTagComp, SpaceTreeShow, CloudedGlass},
  inject: ['overflow'],
  mounted() {
    this.overflow()
    this.getDeviceCategoryList();
    
    // 检查路由参数，如果有 spaceId 和 typeEngName，自动进行查询
    if (this.$route.query.spaceId) {
      // 设置空间信息
      this.spaceInfo = {
        id: this.$route.query.spaceId,
        title: this.$route.query.spaceName || '指定空间'
      };
      
      // 设置当前空间ID，用于空间树选中
      this.currentSpaceId = this.$route.query.spaceId;
      
      // 设置设备类型
      if (this.$route.query.typeEngName) {
        this.typeEngName = this.$route.query.typeEngName;
      }
      
      // 延迟执行查询，确保组件已初始化
      setTimeout(() => {
        // 执行查询
        this.getDeviceList();
      }, 500); // 增加延迟，确保空间树已完全加载
    }
  },
  props: {
    selectSpaceInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      // 筛选的空间名称
      name: "",
      hasDevice: true,
      deviceInfoList: {},
      deviceTagList: [],
      spaceInfo: {},
      deviceName: '',
      dialogVisible: false,
      // 设备总数
      deviceCount: 0,
      typeEngName: '',
      // 设备类型下拉数据
      deviceCategory: [],
      // 当前选中的空间ID（用于空间树选中）
      currentSpaceId: null,
    }
  },
  methods: {
    // 获取设备类型
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.deviceCategory = res.data;
        }
    });
    },
    getAllDevice() {
      this.spaceInfo = {}
      this.getDeviceList();
    },
    spaceChoose(spaceInfo) {
      this.spaceInfo = spaceInfo;
      this.getDeviceList();
    },
    getDeviceList() {
      this.deviceInfoList = [];
      this.deviceTagList = [];
      getListWithTagBySpaceId(this.spaceInfo.id, this.deviceName, this.typeEngName).then(res => {
        this.deviceInfoList = res.data.deviceInfoListMap
        this.deviceTagList = res.data.tagNameList
        // 累加设备总数
        this.deviceCount = 0
        res.data.tagNameList.forEach(tag => {
          let deviceList = res.data.deviceInfoListMap[tag]
          if (deviceList.length > 0) {
            this.deviceCount += deviceList.length
          }
        })
        this.check();
      })
    },
    check() {
      this.hasDevice = true;
      for( let tag of this.deviceTagList ) {
        let item = this.deviceInfoList[tag];
        if (item !== null && item.length > 0) {
          return this.hasDevice = false;
        }
      }
    },
    changeName(){
      this.$refs.spaceTree.changName(this.name);
    }
  }
}
</script>

<style scoped>
.device-list {
  overflow-y: auto;
  height: 95%;
  padding: 20px;
}
.device-list::-webkit-scrollbar { width: 0 !important }

/*搜索*/
.search-content {
  width: auto;
  padding-bottom: 6px;
}

.search-input {
  color: white;
  padding-left: 20px;
  width: 265px;
  max-width: 265px;;
  height: 35px;
  vertical-align: middle;
  background-color: rgba(1, 1, 1, 0);
  border: 1px solid #299FFB;
  border-radius: 4px 0 0 4px;
  opacity: 0.4;
}

.search-input:focus {
  outline: none;
  border: 1px solid #299FFB;
  opacity: 0.8;
}

.search-btn {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 37px;
  background: rgba(41, 155, 255, 0.2);
  border-radius: 0 4px 4px 0;
  text-align: center;
  line-height: 37px;
}

.search-btn:hover {
  background: rgba(41, 155, 255, 0.5);
  cursor: pointer;
}

.main {
  height: calc(100vh - 85px);
}

/*空间*/
.space-choose {
  float: left;
  height: 100%;
  width: 210px;
}

.deviceCount {
  font-size: 14px;
  font-family: Alibaba PuHuiTi Regular;
  color: #CCCCCC;
  margin-left: 10px;
}

.space-choose .current-location, .space-choose .space {
  margin: 30px 0 5px 27px;
  font-size: 0.85rem;
}

.main .device-list {
  width: calc(100vw - 260px);
}

.search-media {
  width: 88%;
}

@media (max-width: 1600px ) {

  .search-media {
    width: 85%;
  }
}

@media (max-width: 555px) {

  .space-choose {
    float: left;
    width: 100%;
    height: auto;
  }

  .main .device-list {
    margin-left: 0;
    width: 100vw;
    height: auto;
  }
}

</style>
